module.exports = __webpack_public_path__ + "images/emoji/bullettrain_side.536aefb61b7bf3d29fd8.png";